import React from "react";
import Card from "../../components/Card/Card";
import { CardGridWrapper } from "../../components/Card/CardGridWrapper";
import TitleBanner from "../../components/TitleBanner/TitleBanner";

function Tickets({ paidProducts, updateList, setUpdateList }) {
  return (
    <div>
      <TitleBanner
        color="blue"
        title="As suas compras"
        subtitle="Para usufruir das suas reservas, apresente o código das suas compras."
      />

      <CardGridWrapper>
        {paidProducts.length > 0 &&
          paidProducts?.map((product, index) => (
            // <ReservationCard store={r} key={index}></ReservationCard>
            <Card
              entity={product.type}
              product={product}
              key={index}
              updateList={updateList}
              reserveBtn={false}
              messagesBtn={true}
              setUpdateList={setUpdateList}
              context="ticket"
            >
              <div className="ahp-ticket label">Código</div>
              <div className="ahp-ticket code">{product.ticket}</div>
            </Card>
          ))}
      </CardGridWrapper>
    </div>
  );
}

export default Tickets;
